import { Pagination, Stack, Button, Select, MenuItem, Typography } from '@mui/material';

export function CustomPagination({ pagination, onPageChange, limit, onLimitChange }) {
  return (
    <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" mt={2} flexWrap="wrap">
      
      {/* Limit Selector */}
      <Stack direction="row" spacing={1} alignItems="center">
        <Typography variant="body2">Rows per page:</Typography>
        <Select
          value={limit}
          onChange={(e) => onLimitChange(Number(e.target.value))}
          size="small"
        >
          {[5, 10, 25, 50, 100].map((option) => (
            <MenuItem key={option} value={option}>{option}</MenuItem>
          ))}
        </Select>
      </Stack>

      {/* Prev Button */}
      <Button
        disabled={!pagination?.hasPrevPage}
        onClick={() => onPageChange(pagination?.currentPage - 1)}
      >
        Previous
      </Button>

      {/* Pagination */}
      <Pagination
        count={pagination?.totalPages}
        page={pagination?.currentPage}
        onChange={(e, page) => onPageChange(page)}
        color="primary"
      />

      {/* Next Button */}
      <Button
        disabled={!pagination?.hasNextPage}
        onClick={() => onPageChange(pagination?.currentPage + 1)}
      >
        Next
      </Button>
    </Stack>
  );
}
